import { Fragment, h } from "preact";
import { RouterProps } from "preact-router";
import { Container, ToastViewer } from "uitoolkit";
import { usePageTitle } from "hooks";
import { Sidebar } from "components/sidebar";
import { TextEditor, tokenizeJs } from "components/texteditor";
import { useEffect, useState } from "preact/hooks";
import { BackendDocument, getDocument } from "services/backend/documents";

export function NotesPage(props: { id?: string } & RouterProps) {
    const [doc, setDoc] = useState<BackendDocument>(null);

    usePageTitle((doc ? `${doc.title} - ` : "") + "Notes");

    console.log("ID", props.id);
    useEffect(() => {
        if(!props.id) return;
        getDocument(props.id)
            .then(doc => {
                if(doc) {
                    setDoc(doc)
                    console.log(doc?.content);
                }
            });
    }, [props.id]);

    return (
        <Fragment>
            <Container class="row grow maxheight-100vh overflow-y-hidden">
                <Sidebar page="notes" />
                <Container class="flex-column overflow-y-auto grow">
                    <TextEditor tokenizer={tokenizeJs} initialContent={doc?.content} />
                </Container>
            </Container>
            <ToastViewer />
        </Fragment>
    );
}
